<template>
    <div class="container-fluid">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <ValidationProvider
                  :name="'Shartnoma'"
                  rules="required"
                  v-slot="{ errors }"
              >
                <label>
                  Shartnoma
                  <input
                      v-model="form.contract_number"
                      type="text"
                      placeholder="shartnoma"
                      :disabled="!isAdmin"
                  >

                  <span class="text-danger">{{ errors[0] }}</span>
                </label>
              </ValidationProvider>
                <ValidationProvider
                    :name="$t('modal.form.full_name.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.full_name.label') }}
                        <input
                            v-model="form.full_name"
                            type="text"
                            :placeholder="$t('modal.form.full_name.placeholder')"
                        >

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('table.bottles_count')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('table.bottles_count') }}
                        <div class="w-100 d-flex">
                            <input
                                disabled
                                v-model="form.bottles_count"
                                type="number"
                                :placeholder="$t('table.bottles_count')"
                            >
                        </div>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('modal.form.driver.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.driver.label') }}
                        <v-select
                            v-model="form.driver_id"
                            :options="driver_options"
                        ></v-select>

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('modal.form.address.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.address.label') }}
                        <input
                            id="address"
                            v-model="form.address"
                            type="text"
                            :placeholder="$t('modal.form.address.placeholder')"
                        >

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('modal.form.status.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.status.label') }}
                        <v-select
                            v-model="form.status_id"
                            :options="clientStatuses"
                        ></v-select>

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('modal.form.notify_loop.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.notify_loop.label') }}
                        <v-select
                            v-model="form.notify_loop"
                            :options="notify_options"
                        ></v-select>

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    :name="$t('modal.form.branch.label')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label>
                        {{ $t('modal.form.branch.label') }}
                        <v-select
                            v-model="form.branch_id"
                            label="name"
                            :reduce="(options) => options.id"
                            :options="branch_options"
                        ></v-select>

                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>

                <!-- <ValidationProvider
                  :name="$t('modal.form.warehouse.label')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>
                    {{ $t('modal.form.warehouse.label') }}
                    <v-select
                      v-model="form.warehouse_id"
                      label="name"w
                      :reduce="(options) => options.id"
                      :options="warehouse_options"
                    ></v-select>

                    <span class="text-danger">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider> -->

                <div
                    v-for="(mobile, index) in form.numbers"
                    :key="index"
                >
                    <ValidationProvider
                        :name="$t('modal.form.numbers.label')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label>
                            {{ $t('modal.form.numbers.label') }}
                            <div class="d-flex">
                                <input
                                    id="numbers"
                                    v-model="mobile.mobile"
                                    v-mask="'###(##)###-##-##'"
                                    type="text"
                                    :placeholder="$t('modal.form.numbers.placeholder')"
                                >

                                <b-button
                                    variant="outline-danger"
                                    @click="deleteObject(index)"
                                >
                                    <i class="bx bx-trash"></i>
                                </b-button>
                            </div>
                            <span class="text-danger">{{ errors[0] }}</span>
                        </label>
                    </ValidationProvider>
                </div>

                <div class="d-flex justify-content-end">
                    <b-button
                        variant="success"
                        size="sm"
                        @click="increaseNumber()"
                    >
                        <i class="bx bx-plus"></i>
                    </b-button>
                </div>

                <label class=" d-flex align-items-center">
                    <p class="label_title">{{ $t('modal.form.is_physical.label') }}</p>
                    <input class="w-auto"
                           type="checkbox"
                           v-model="form.is_physical"
                    >
                </label>

                <b-button class="float-end ms-3"
                          variant="success"
                          type="submit" :disabled="db"
                >
                    {{ $t('modal.button.post') }}
                </b-button>

                <b-button class="float-end"
                          variant="warning"
                          @click="onClose()"
                >
                    {{ $t('modal.button.back') }}
                </b-button>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import {putClients, getClientsByID} from '../../../api/endpoints/clients';
import {getBranchID} from '../../../api/endpoints/branches'

export default {
    name: "ClientsPutModal",
    props: {
        id: {
            type: Number,
            required: true
        },
        branch_options: {
            type: Array,
            required: true
        },
        warehouse_options: {
            type: Array,
            required: true
        },
        driver_options: {
            type: Array,
            required: true
        },
        notify_options: {
            type: Array,
            required: true
        },
        clientStatuses: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            form: {
                id: null,
                full_name: "",
                bottles_count: null,
                driver_id: null,
                address: "",
                numbers: [],
                is_physical: false,
                status_id: null,
                notify_loop: null,
                branch_id: null,
                warehouse_id: null,
                location: [],
              contract_number: null,
            },
            options: [
                {value: 1, label: "ID 1"},
                {value: 2, label: "ID 2"},
                {value: 3, label: "ID 3"},
                {value: 4, label: "ID 4"},
                {value: 5, label: "ID 5"},
            ],
            db: false,
        }
    },
  computed: {
    isAdmin() {
      return this.$store.state.auth.authUser.roles.map(item => item.name).includes('SuperAdmin');
    }
  },
    methods: {
        onSubmit() {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
            this.form.location = []
            this.form.numbers.forEach(el => {
                const e = el.mobile;
                let mobile = e.replace(')', '');
                mobile = mobile.replace('+', '');
                mobile = mobile.replace('(', '');
                mobile = mobile.replace(/ /g, '');
                mobile = mobile.replace(/-/g, '');
                el.mobile = mobile;
            })
            putClients({
                id: this.form.id,
                full_name: this.form.full_name,
                bottles_count: this.form.bottles_count,
                driver_id: this.form.driver_id.value,
                address: this.form.address,
                numbers: this.form.numbers,
                telegram_id: null,
                is_physical: this.form.is_physical,
                status_id: this.form.status_id.value,
                notify_loop: this.form.notify_loop,
                branch_id: this.form.branch_id.value,
                contract_number: this.form.contract_number,
                // warehouse_id: this.form.warehouse_id
            }).then(() => {
                this.onClose();
            })
        },
        onClose() {
            this.$emit('onClose')
        },
        increaseNumber() {
            this.form.numbers.push({
                mobile: null
            });
        },
        deleteObject(index) {
            this.form.numbers.splice(index, 1)
        },
        getBranchForForm(id) {
            getBranchID(id).then(res => {
                this.form.branch_id = {
                    value: res.data.data.id,
                    label: res.data.data.name
                }
            })
        },
    },
    watch: {
        id: {
            immediate: true,
            handler() {
                getClientsByID(this.id).then(res => {
                    let resData = res.data.data
                    this.form = resData;
                    this.form.status_id = {value: res.data.data.status.id, label: res.data.data.status.name}
                    this.form.driver_id = {value: resData.driver.id, label: resData.driver.full_name}
                    this.form.branch_id = resData.branch_id
                })
            }
        }
    }
}
</script>
